import { Route, Routes} from 'react-router-dom'
import { RoutesPrivate } from './ProtectedRoute'
import Cookies from 'js-cookie'
import EnvioAlerta from '../Pages/EnvioAlerta'

const PrivateRoutes = () => { 

    const rol = Cookies.get('rol');

  return (
    <Routes>
        <Route path='*' element={<EnvioAlerta />} />
        <Route path={RoutesPrivate.CIFRANEGRA} element={<EnvioAlerta />} />

        {/* Page Not Found */}
    </Routes>
  )
}
export {PrivateRoutes}
